import React from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const CircularBar = ({ value = 0, color }) => {

  return (
    <div className='circularBar'>
      <CircularProgressbar
        value={value}
        text={`${value}%`}
        strokeWidth={5}
        circleRatio={0.5}
        styles={buildStyles({
          rotation: 0.75,
          strokeLinecap: 'round',
          trailColor: '#f0f0f0',
          pathColor: color,
          textColor: '#003C5D',
          pathTransitionDuration: 0.5,
          textSize: '20px',
          style: {
            fontWeight: '900',
            fontFamily: 'Lato',
            lineHeight: '10px'
          }
        })}
      />
    </div>
  );
}

export default CircularBar;
